import { OperatorMaterialDetails } from "./OperatorMaterialDetails";
import { TouchSheet } from "./TouchSheet";
import { useOperatorMaterials } from "./useOperatorMaterials";
import "./operator-materials.css";

export function OperatorMaterialsSheet({runId,terminalCode,sessionId,close}:{runId:string;terminalCode:string;sessionId:string;close:()=>void}) {
  const workspace=useOperatorMaterials(runId,terminalCode,sessionId);
  return <TouchSheet title="Reçete ve stoklar" variant="details" close={close} actions={<div className="operator-materials-actions"><button type="button" onClick={workspace.refresh} disabled={workspace.loading}>{workspace.loading ? "Okunuyor…" : "Yeniden oku"}</button></div>}>
    <div className="operator-material-sheet-body">
    {workspace.loading?<p role="status">Reçete ve stoklar okunuyor…</p>:null}
    {workspace.error?<p role="alert">{workspace.error} {workspace.value?"Son doğrulanan bilgiler korunuyor; güncel okuma başarısız.":"Yeniden okuyarak deneyin."}</p>:null}
    {workspace.value?<OperatorMaterialDetails value={workspace.value}/>:null}
    </div>
  </TouchSheet>;
}
